export default "__VITE_ASSET__DNRS7wpV__"